import { colorsList } from "../data/colorsList";
import HistoryTableHeader from "./calendarTable/HistoryTableHeader";
import HistoryTableBody from "./calendarTable/HistoryTableBody";
import { writeLapsus } from "../functions/writeLapsus";

const lapsus = writeLapsus();

export default function CalendarTable({ data }) {
  return (
    <table
      style={{
        position: "relative",
        width: "100%",
        borderRadius: 5,
        backgroundColor: colorsList.white,
        border: `2px solid ${colorsList.darkGrey}`,
      }}
    >
      <HistoryTableHeader lapsus={lapsus} />
      <HistoryTableBody lapsus={lapsus} data={data} />
    </table>
  );
}
